// Module
var code = "<ticket-status status=pending deadline=vm.ticket.nextDeadlineInBankDays title=\"{{ 'app.ticket.status.' + vm.stateName + '.' + vm.ticket.status + '.pending.title' }}\" body=\"{{ 'app.ticket.status.' + vm.stateName + '.' + vm.ticket.status + '.pending.body' }}\" cta=\"vm.navigateTo('list')\" cta-title=app.tickets.back> </ticket-status> ";
// Exports
var _module_exports = code;;
var path = 'app/components/ticket/partials/ticket.statusPending.tpl.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;